import { Button, Card, Tooltip } from "pepsico-ds";
import "./SystemSettingCard.scss";

const SystemSettingCard = ({
  id,
  name,
  description,
  onClickEdit,
  onClickView,
  hasEditAccess,
}) => {
  return (
    <Card
      className="card-container"
      // icon=""
      // ellipsis=""
      style={{
        padding: "0px",
        borderRadius: "10px",
        boxShadow: "none",
        backgroundColor: "#fff",
        border: "1px solid rgb(215, 229, 248)",
      }}
    >
      <div className="card-container">
        <div className="details">
          <div className="card-content">
            {name.length > 60 ? (
              <Tooltip direction="right" text={name}>
                <h3 className="name">{name.substring(0, 60)}...</h3>
              </Tooltip>
            ) : (
              <h3 className="name">{name}</h3>
            )}

            <div className="description">
              {description !== null && (
                <div className="meta-item">
                  <span className="description-text" title={description}>
                    {description}
                  </span>
                </div>
              )}
            </div>
          </div>

          <div className="button-group-container">
            {hasEditAccess ? (
              <Button
                variant="secondary"
                size="small"
                iconLeading="edit"
                onClick={() => onClickEdit(id)}
              >
                Edit
              </Button>
            ) : (
              <Button
                variant="secondary"
                size="small"
                iconLeading="visibility"
                onClick={() => onClickView(id)}
              >
                View
              </Button>
            )}
          </div>
        </div>
      </div>
    </Card>
  );
};

export default SystemSettingCard;
